@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.error-wrapper,
.summary {
  width: 280px;
  margin: -1px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 13px;
  line-height: 24px;
}

.summary-header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 6px 0 6px 15px;
  border-bottom: 1px solid @customer-summary--header--border-color;
}

.summary-content {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 9px 13px 9px 15px;
}

.totals-row,
.order-status-row {
  display: flex;

  > * {
    width: 50%;
  }
}

.totals-row {
  font-weight: @bold;
}

.disclaimer {
  font-size: 12px;
  font-style: italic;
  padding-top: 5px;
}

.spacer {
  margin: 9px 0 7px;
  border-top: 1px solid @customer-summary--spacer--border-color;
  border-bottom: 1px solid @customer-summary--spacer--border-color;
}

.recipient {
  font-weight: @bold;
  font-size: 14px;
  height: 20px;
}

.link-behavior {
  &:hover {
    color: @customer-summary--link-behavior--hover--text-color;
    cursor: pointer;
  }
}

.recipient-name {
  .truncate();
  line-height: 30px;
  margin-left: 5px;
}

.error-wrapper {
  align-items: center;
  padding-bottom: 15px;

  .error {
    width: 50px;
    height: 50px;
    margin: 15px auto;
  }
}

.loading {
  height: 30px;
  width: 30px;
  align-self: center;
}
